module.exports = __webpack_public_path__ + "img/sample-messages.07682ec4.svg";